import React from "react";
import Reports from "@/pages/TenantAdmin/Reports";
export default function ManagerReports() {
  return <Reports />;
}
